const topics = [
  { label: '动作大片', icon: 'ri-sword-fill', color: 'bg-primary-100 text-primary-700' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', color: 'bg-accent-100 text-accent-800' },
  { label: '浪漫爱情', icon: 'ri-heart-3-fill', color: 'bg-pink-100 text-pink-600' },
  { label: '科幻巨制', icon: 'ri-rocket-2-fill', color: 'bg-indigo-100 text-indigo-600' },
  { label: '爆笑喜剧', icon: 'ri-emotion-laugh-fill', color: 'bg-amber-100 text-amber-600' },
  { label: '国剧精选', icon: 'ri-tv-2-fill', color: 'bg-green-100 text-green-600' },
  { label: '高分经典', icon: 'ri-medal-fill', color: 'bg-yellow-100 text-yellow-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            热门专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">精选影视分类，快速发现你想看的内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer no-underline"
            >
              <div className={`w-12 h-12 rounded-full ${topic.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <i className={`${topic.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}